<h2 mat-dialog-title>Usuario</h2>
<mat-dialog-content>
    <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
        <mat-form-field class="example-full-width">
          <mat-label>Nombre</mat-label>
          <input formControlName="nombre" matInput placeholder="Nombre del usuario" value="">
          <mat-error>El nombre es requerido</mat-error>
        </mat-form-field>
        <input type="hidden" formControlName="id" value="">

          <mat-form-field  appearance="outline" class="example-full-width">
            <mat-label>Tipo Documento</mat-label>
            <mat-select formControlName='tipoDoc'>
              <mat-option *ngFor="let documento of documentos" [value]="documento.value">
                {{documento.nombre}}
              </mat-option>
            </mat-select>
            <mat-error>El tipo de documento es requerido</mat-error>
          </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Documento</mat-label>
            <input formControlName='documento' matInput placeholder="Documento del usuario" value="">
            <mat-error>El documento es requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Email</mat-label>
            <input formControlName='email' matInput placeholder="Email del usuario" value="">
            <mat-error>{{getErrorMessageEmail()}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Celular</mat-label>
            <input formControlName='celular' matInput placeholder="Numero celular del usuario" value="">
            <mat-error>El celular es requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Teléfono</mat-label>
            <input formControlName='telefono' matInput placeholder="Teléfono del usuario" value="">
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Dirección</mat-label>
            <input formControlName='direccion' matInput placeholder="Dirección del usuario" value="">
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Ciudad</mat-label>
            <input formControlName='ciudad' matInput placeholder="Ciudad del usuario" value="">
          </mat-form-field>

          <mat-form-field  appearance="outline" class="example-full-width">
            <mat-label>Perfil</mat-label>
            <mat-select formControlName='perfil'>
              <mat-option *ngFor="let perfil of perfiles" [value]="perfil.id">
                {{perfil.nombre}}
              </mat-option>
            </mat-select>
            <mat-error>El perfil es requerido</mat-error>
          </mat-form-field>
      </form>

</mat-dialog-content>
<mat-dialog-actions>
    <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()'>Guardar</button>
    <button mat-button mat-dialog-close='false' >Cancelar</button>
</mat-dialog-actions>
